import React from 'react'
import PropTypes from 'prop-types'
import CopyToClipboard from 'react-copy-to-clipboard'
import ReactTooltip from 'react-tooltip'

function CopyTextOnClick({
  text,
  id,
  children = null,
  isWithTooltip = true,
}) {
  return (
    <CopyToClipboard text={text}>
      {isWithTooltip ? (
        <span>
          <div
            data-tip="Click to copy"
            data-for={`tooltip-${id}`}
          >
            {children}
          </div>
          <ReactTooltip
            type="light"
            effect="solid"
            id={`tooltip-${id}`}
          />
        </span>
      ) : (children)}
    </CopyToClipboard>
  )
}

CopyTextOnClick.propTypes = {
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.node,
  isWithTooltip: PropTypes.bool,
}

export default CopyTextOnClick
